// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"be09b2c2","732":"2658b9c4","977":"11b9e728"}[chunkId] + ".chunk.js";
};